module.exports = __webpack_public_path__ + "img/ai03.06448e4e.png";